import { firstValueFrom } from "rxjs";
import { AuthenticationService } from "src/app/services/authentication.service";
import { UserService } from "src/app/services/user.service";

import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";

import { EmployeesService } from "../../employees/services/employees.service";
import { EvaCompanyService } from "../../eva-company/services/evaCompany.service";

@Component({
  selector: "app-redirect",
  templateUrl: "./redirect.component.html",
  styleUrl: "./redirect.component.scss",
})
export class RedirectComponent implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private evaCompanyService: EvaCompanyService,
    private userService: UserService,
    private employeesService: EmployeesService,
  ) {}

  ngOnInit() {
    // get token from url
    this.route.queryParams.subscribe(async (params) => {
      const token = params["token"];
      const tokenRefresh = params["tokenRefresh"];
      const eva_company_id = params["eva_company_id"];

      if (!token || !tokenRefresh) {
        this.authenticationService.logout();
        this.router.navigate(["/login"]);
        return;
      }
      localStorage.setItem("evaJwt", token);
      localStorage.setItem("evaRefreshJwt", tokenRefresh);

      try {
        let evaCompanies = await firstValueFrom(this.evaCompanyService.getAll());
        if (!evaCompanies) {
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
          return;
        }
        this.evaCompanyService.updateEvaCompanies(evaCompanies);

        let selectedEvaCompany = evaCompanies.find((company) => company.eva_company_id === eva_company_id);
        if (!selectedEvaCompany) {
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
          return;
        }
        this.evaCompanyService.updateEvaCompany(selectedEvaCompany);

        let user = await firstValueFrom(this.userService.get());
        if (!user) {
          this.authenticationService.logout();
          this.router.navigate(["/login"]);
          return;
        }
        this.authenticationService.updateUser(user);

        let evaEmployee = await firstValueFrom(this.employeesService.getCurrentEmployee(false));
        this.evaCompanyService.updateEmployee(evaEmployee);

        this.evaCompanyService.redirectTo("/home");
      } catch (error) {
        this.authenticationService.logout();
        this.router.navigate(["/login"]);
      }
    });
  }
}
